export default Object.freeze({
  check: 'check',
  checksq: 'checksq',
  checkx: 'checkx',
  date: 'date',
  signature: 'signature',
  number: 'number',
  phone: 'phone',
  text: 'text',
})



// WEBPACK FOOTER //
// ./src/models/DocFieldType.js